/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_EditInputs */



/**

* @param {_Wiki_EditInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _wiki_edit = /** @type {((inputs?: _Wiki_EditInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_EditInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Bearbeiten")
});